/*  ========================================================================
    # Main JavaScript
    ========================================================================  */

import PageStatus from './scripts/page-status';
import ContactDialog from './scripts/contact-dialog';
import Cards from './scripts/cards';
import ImageSlider from './scripts/image-slider';
import Menu from './scripts/menu';

const scripts = [PageStatus, ContactDialog, Cards, ImageSlider, Menu];

document.addEventListener('DOMContentLoaded', () => {
  if (scripts.length > 0 && scripts !== undefined) {
    scripts.forEach(script => {
      script.init();
    });
  }

  // Lazy-load Hero module only if hero section exists
  if (document.querySelector('.s-hero__image-figure--animated')) {
    import('./scripts/hero').then(module => {
      module.default.init();
    });
  }
});
